import { FeatureValue } from '../entities';
import { useFeatureFlags } from './useFeatureFlags';

/**
 * @deprecated Use `useFeatureValue()` instead.
 */
export function useExperimentGroup<T extends FeatureValue>(experimentName: string) {
  const { featureFlags } = useFeatureFlags();

  return featureFlags.getExperimentGroup<T>(experimentName);
}
